export default {
    ABERTO: 'Aberto',
    FINALIZADO: 'Finalizado',
    CANCELADO: 'Cancelado'
}
